'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var IS_CALL_API = Symbol('IS_CALL_API');
var IS_AXIOS = Symbol('IS_AXIOS');

exports.default = {
  IS_CALL_API: IS_CALL_API,
  IS_AXIOS: IS_AXIOS
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/user-permissions/lib/symbols/index.js
 ** module id = 254
 ** module chunks = 0
 **/